/**
 * Created by vsliwka on 07/06/2017.
 */

export class ReferentialEntityStateModel {
  public deleted: boolean;
  public blocked: boolean;
  public activated: boolean;
  public updatable: boolean;

  constructor() {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
        return this;
      }
    }
  }
}
